import styled from "styled-components";

export const StyleTabs = styled.div`
  width: 100%;
`;
